import React from "react";
import {
  IconButton, TableCell, TableRow, Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@mui/material";
import { Inventory } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IGroup } from "../controller";
import { Grading } from "@mui/icons-material";

export interface ManagedGroupRowDelegate {
  didClickArchive(groupId: string): void;
  didClickCopyGroup(groupId: number): void;
}

interface State {
  anchorEl: null | HTMLElement;
  isLoading: boolean;
}

interface Props {
  group: IGroup;
  delegate: ManagedGroupRowDelegate;
}

class ManagedGroupRow extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      anchorEl: null,
      isLoading: false,
    };
  }

  handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (action: () => void) => {
    this.handleMenuClose();
    action();
  };

  didClickArchive(groupId: string) {
    this.props.delegate.didClickArchive(groupId);
  }

  didClickCopyGroup(groupId: string) {
    this.setState({
      isLoading: true
    });
    this.props.delegate.didClickCopyGroup(+groupId);
  }

  render() {
    const menuOpen = Boolean(this.state.anchorEl);

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' }, display: this.props.group.archived ? 'none' : 'table-row' }}>
          <TableCell component="th" scope="row">{this.props.group.name}</TableCell>
          <TableCell component="th" scope="row">{this.props.group.instrument_title}</TableCell>
          <TableCell align="right">
            <IconButton
              aria-label="actions"
              size="medium"
              sx={{
                backgroundColor: "grey.200",
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "grey.300",
                },
              }}
              onClick={this.handleMenuClick}
              title="Mais opções"
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              anchorEl={this.state.anchorEl}
              open={menuOpen}
              onClose={this.handleMenuClose}
              MenuListProps={{
                'aria-labelledby': 'actions-button',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={() => this.handleMenuItemClick(() => this.didClickCopyGroup(this.props.group.id))}>
                <ListItemIcon>
                  <Grading fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Ver devolutiva agregada" />
              </MenuItem>

              <Divider />

              <MenuItem onClick={() => this.handleMenuItemClick(() => this.didClickArchive(this.props.group.id))}>
                <ListItemIcon>
                  <Inventory fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText primary="Arquivar devolutiva agregada" />
              </MenuItem>
            </Menu>
          </TableCell>
        </TableRow>
      </React.Fragment>
    )
  }
}

export default ManagedGroupRow;
